import type {
  ImportRoom,
  ImportSeason,
} from '@sportninja/common/services/teamBalance'
import { registrationSeasonSubtitle } from '@sportninja/common/features/team-balance/utils/registrationSeasons'
import { balanceText } from './balanceI18n'
import { MAX_IMPORT } from './importSelection'
import type { ImportSummary } from './importSelection'

/**
 * Jeff, Oct 1 — a previous season's second line in the picker: its dates, as the
 * Registration tab's Season picker writes them, and how many regulars it had.
 */
export const importSeasonMeta = (
  season: Pick<ImportSeason, 'starts_at' | 'ends_at' | 'player_count'>
): string =>
  balanceText('common:balanceImportSeasonMeta', {
    dates: registrationSeasonSubtitle({
      starts_at: season.starts_at,
      ends_at: season.ends_at,
      organization_name: null,
    }),
    count: season.player_count,
  })

/**
 * The lines under the import grid, in the order they matter: nobody left to
 * invite; players still needing an address; the division's room (what is left
 * after this Send, or how many to untick); the cap on one Send.
 */
export const importHints = (
  summary: ImportSummary,
  room: ImportRoom | null
): string[] => {
  if (summary.everyoneIn) {
    return [balanceText('common:balanceImportEveryoneIn')]
  }

  const hints: string[] = []
  if (summary.needEmail > 0) {
    hints.push(
      balanceText('common:balanceImportNeedsEmail', {
        count: summary.needEmail,
      })
    )
  }
  if (room && summary.overRoomBy > 0) {
    hints.push(
      balanceText('common:balanceImportRoomOver', {
        max: room.max_players,
        count: summary.overRoomBy,
      })
    )
  } else if (room && summary.roomLeft !== null) {
    hints.push(
      balanceText('common:balanceImportRoom', {
        max: room.max_players,
        count: summary.roomLeft,
      })
    )
  }
  if (summary.overCap) {
    hints.push(balanceText('common:balanceImportMax', { max: MAX_IMPORT }))
  }

  return hints
}
